import { getYotpoInstanceId } from "helpers/yotpo";
import { FC } from "react";

type StarReviewsProps = {
  gtin: string | null | undefined;
};

export const StarReviews: FC<StarReviewsProps> = ({ gtin }) => {
  if (!gtin) {
    return null;
  }

  return (
    <div
      className="yotpo-widget-instance"
      data-yotpo-instance-id={getYotpoInstanceId("stars")}
      data-yotpo-product-id={gtin}
    />
  );
};
